import React from 'react';

const OnboardingPage = () => {
  return (
    <div className="space-y-6">
      <div className="md:flex md:items-center md:justify-between">
        <div className="flex-1 min-w-0">
          <h2 className="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate">
            Onboarding
          </h2>
          <p className="mt-1 text-sm text-gray-500">
            Onboarding functionality will be implemented here.
          </p>
        </div>
      </div>

      <div className="bg-white shadow rounded-lg">
        <div className="px-4 py-5 sm:p-6">
          <div className="text-center py-12">
            <div className="mx-auto h-12 w-12 bg-gray-100 rounded-full flex items-center justify-center">
              <span className="text-gray-400 text-xl">🚧</span>
            </div>
            <h3 className="mt-4 text-lg font-medium text-gray-900">Coming Soon</h3>
            <p className="mt-2 text-gray-500">
              This onboarding section is under development.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnboardingPage;